module.exports = __webpack_public_path__ + "img/add_quote.3466d1f5.png";